import {
  FloatingFormItem,
  InputDate,
  CompaniesInfiniteSelectField,
} from '@/components/_common';
import { Col, Form, Modal, ModalProps, Row } from 'antd';
import moment from 'moment';
import { Moment } from 'moment';

export interface ChartDefaultFilterValues {
  startDate: Moment;
  endDate: Moment;
  companiesIds: number[];
}

interface Props extends Omit<ModalProps, 'onOk' | 'title'> {
  onOk: (values: ChartDefaultFilterValues) => void;
  title: string;
}

export default function ChartDefaultFilter(props: Props) {
  const [form] = Form.useForm<ChartDefaultFilterValues>();
  const formValues = Form.useWatch([], form);

  return (
    <Modal
      {...props}
      onOk={() =>
        props.onOk({
          ...formValues,
          startDate: formValues?.startDate.startOf('day'),
          endDate: formValues?.endDate.startOf('day'),
        })
      }
      okText="Atualizar Gráfico"
    >
      <Form layout="vertical" form={form}>
        <Row gutter={24}>
          <Col span={24}>
            <FloatingFormItem
              name="startDate"
              label={'Data Inicial'}
              initialValue={moment().subtract(5, 'months').startOf('month')}
            >
              <InputDate />
            </FloatingFormItem>
          </Col>

          <Col span={24}>
            <FloatingFormItem
              name="endDate"
              label={'Data Final'}
              initialValue={moment().endOf('day')}
            >
              <InputDate />
            </FloatingFormItem>
          </Col>

          <Col span={24}>
            <FloatingFormItem label={'Empresas'} name="companiesIds">
              <CompaniesInfiniteSelectField mode="multiple" allowClear />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
